import 'css-chunksrc/client/scenes/taskStatusRemoval/status/styles.scss';export default {
  "status": "_status_ol9zq_1",
  "label": "_label_ol9zq_9"
};